import {atom, useAtom} from 'jotai'

export const successModalVisibleAtom = atom<boolean>(false)

export function useSuccessModalVisibleAtom() {
  return useAtom(successModalVisibleAtom)
}
